"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePopup = void 0;
var Utils_1 = require("common/Utils");
var BasePopup = /** @class */ (function () {
    function BasePopup(_a) {
        var _this = this;
        var url = _a.url, name = _a.name, _b = _a.features, features = _b === void 0 ? "location=yes,clearcache=yes" : _b;
        this._popupInitTimeout = 5000;
        this.popupExists = function () {
            if (!_this._popup)
                return false;
            return !_this._popup.closed;
        };
        this.getWindow = function () {
            return _this._popup;
        };
        this.navigateTo = function (url) {
            if (_this._popup && !_this._popup.closed) {
                _this._popup.location.href = url;
                _this._popup.focus();
            }
        };
        this._waitUntilInitialized = function (popup) {
            var _popupInit = false;
            var startTime = new Date().getTime();
            var timePassed;
            while (!_popupInit) {
                if (popup && Utils_1.Utils.isFunction(popup.addEventListener)) {
                    _popupInit = true;
                }
                timePassed = new Date().getTime() - startTime;
                if (timePassed >= _this._popupInitTimeout) {
                    throw new Error("Popup initialization timeout");
                }
            }
        };
        this._createPopup = function () {
            var popup = window.open(_this._url, _this._name, _this._features);
            _this._waitUntilInitialized(popup);
            return popup;
        };
        this.destroy = function () {
            var _a;
            (_a = _this._popup) === null || _a === void 0 ? void 0 : _a.close();
        };
        this._url = url;
        this._name = name;
        this._features = features;
        this._popup = this._createPopup();
    }
    return BasePopup;
}());
exports.BasePopup = BasePopup;
